export const CommonTexts = {
  ABOUT: "Acerca de",
  ALERTS: "Alertas",
  TERMS: "Términos de uso",
  LOGIN: "Iniciar sesión",
  PRIVACY: "Política de privacidad",
  WELCOME_BACK_UPPER: "BIENVENIDO DE NUEVO",
  INFO_LOGIN:
    "Al iniciar sesión, aceptas nuestros Términos de uso y Política de privacidad",
  REMEMBER_ME: "Recuérdame",
  CREATE: "Crear",
  EDIT: "Editar",
  SAVE: "Guardar",
  DELETE: "Eliminar",
  RESET: "Restablecer",
  PATIENTS: "Participantes",
  CENTER: "Centro",
  CENTERS: "Centros",
  SELECT_CENTER: "Selecciona el centro",
  NAME: "Nombre",
  SURNAME: "Apellido",
  FULL_NAME: "Nombre completo",
  EMAIL: "Correo electrónico",
  PASSWORD: "Contraseña",
  CONFIRM_PASSWORD: "Confirmar contraseña",
  NEW_PASSWORD: "Nueva contraseña",
  CONFIRM_NEW_PASSWORD: "Confirmar nueva contraseña",
  BIRTHDAY: "Fecha de nacimiento",
  HEIGHT: "Altura",
  HEIGHT_IN_CM: "Altura en centímetros",
  SEX: "Sexo",
  SELECT_SEX: "Selecciona sexo",
  OBSERVATIONS: "Observaciones",
  ORGANIZATION: "Organización",
  PROFILE: "Perfil",
  SELECT_CENTERS: "Selecciona los centros",
  SELECT_ONE_CENTER: "Selecciona un centro",
  SELECT_PATIENTS: "Selecciona los participantes",
  EXPORT: "Exportar",
  EXPORT_TYPE: "Tipo de datos",
  DATE_RANGE: "Entre fechas",
  FROM: "Desde",
  UNTIL: "Hasta",
  TYPES: "Tipos",
  LABELS: "Etiquetas",
  VALUES: "Valores",
  DOWNLOAD: "Descargar",
  MESSAGES: "Mensajes",
  NOTES: "Bloc de notas",
  HEALTH_DATA: "Datos de salud",
  PARTICIPANT_DATA: "Datos del participante",
  STUDY: "Estudio",
  CONTENT: "Contenido",
  REPORT: "Reportes",
  PROFESSIONALS: "Profesionales",
  PROFESSIONALS_MANAGEMENT: "Gestión de profesionales",
  PATIENTS_NAME: "Especifica el nombre del participante",
  PATIENTS_MANAGEMENT: "Gestión de participantes",
  CENTERS_MANAGEMENT: "Gestión de centros",
  CONFIG: "Configuración",
  DUPLICATE: "Duplicar",
  LINKED_FORMS: "Formularios enlazados",
  AUTHOR: "Autor",
  DESCRIPTION: "Descripción",
  NOTIFICATION_TEXT_STYLES: "Notificación de texto con estilos",
  ASSOCIATE: "Asociar",
  SEARCH_PATIENT: "Encuentra un participante",
  FORMS: "Formularios",
  ROLE: "Rol",
  SELECT_ROLE: "Selecciona los roles",
  FILTER: "Filtrar",
  SELECT_FILTER: "Seleccione un filtro",
  DELETE_FILTER: "Eliminar Filtro",
  ADD_FILTER: "Añadir",
  DELETE_FILTERS: "Eliminar",
  FILTER_COLUMN: "Filtrar por columna",
  FILTER_VALUE: "Filtrar por valor",
  FILTER_ERROR: "Debe seleccionar un filtro por columna",
  LOADING_APP: "Cargando Uhda App...",
  EXPIRED_SESSION: "Su sesión ha caducado, por favor vuelva a iniciar sesión",
  USERNAME: "Usuario",
  IMPORT: "Importar",
  SELECT_PATIENT: "Selecciona a un participante para cargar la aplicación",
};

export const CommonErrorsTexts = {
  sexType: "Debe seleccionar un sexo",
  date: {
    invalidDate: "Fecha inválida",
    maxDate: "La fecha debe ser anterior a la seleccionada",
    minDate: "La fecha debe ser posterior a la seleccionada",
    date: "La fecha es requerida",
  },
  required: "El campo es requerido",
};


export const StatsLabels = {
  STEPS: "Pasos",
  HR: "Frecuencia Cardíaca",
  FREQUENCY: "Frecuencia",
  WEIGHT: "Peso",
  CALORIES: "Calorías",
  DISTANCE: "Distancia",
};

export const ParticipantsTexts = {
  EMAIL_REPEAT_ERROR: "Ya existe un participante con el mismo email",
  INVALID_BIRTHDAY_ERROR: "La fecha de nacimiento no es correcta",
  INPUT_VALIDATION_ERROR:
    "No se ha podido crear el participante porque hay un error en los datos proporcionados",
};

export const PatientDetail = {
  TITLE: "Datos del Participante",
  AGE: "Edad",
  HEIGHT: "Estatura",
  INTIALWEIGHT: "Peso inicial",
  BMI: "IMC",
  LASTCOMENT: "Último comentario",
  LASTWEIGHT: "Último peso",
  INTERVENTION: "Intervención",
  INTERVENTION_ERROR: "El participante no tiene asignada ninguna intervención"
};

export const Dashboard = {
  STEPS_DAY_MONTH: "Pasos totales por día al mes",
  AVERAGE_STEPS_DAY: "Media de pasos por día al mes",
  STEPS_HOUR: "Pasos totales por hora al día ",
  CALORIES_HOUR: "Calorias totales por hora al día ",
  HEART_MIN_MAX_HOUR: "Frecuencia mínima y máxima por hora al día ",
  HEART_MIN_MAX_DAY: "Frecuencia mínima y máxima por día en ",
  HEART_INTENSITY: "Intensidad frecuencia cardíaca en el último mes",
  WEIGHT: "Historial de peso",
  SELECT_TYPE: "Seleccione el tipo de datos a exportar",
  TYPE_DATA: "Tipo de datos",
  INITIAL_DATE: "Fecha de inicio",
  END_DATE: "Fecha de fin",
  EXPORT: "Exportar",
  EXPORT_NO_DATA: "No hay datos para exportar en las fechas seleccionadas",
  EXPORT_DATA: "Datos exportados correctamente",
};

export const ConfigFormsLabels = {
  STUDY_ID: "Id. del estudio",
  STUDY_NAME: "Nombre del estudio",
  FORM_ID: "Id. del formulario",
  FORM_NAME: "Nombre del formulario",
  TAG: "Etiqueta",
  START_DATE: "Inicio",
  END_DATE: "Final",
  PRIORITY: "Prioridad",
  IMPORTANT: "Importante",
  REQUIRED: "Obligatorio",
  NOT_REQUIRED: "No obligatorio",
  formInputErrors: {
    tag: "La etiqueta debe tener al menos dos caracteres",
    description: "La descripción debe tener al menos dos caracteres",
    api_error: "El formulario no ha podido ser creado",
    repeated_formTag: "Ya existe un formulario con la misma etiqueta",
    end_date: "La fecha de fin no puede ser anterior a la fecha de incio",
  },
};

export const ProfessionalsTableModals = {
  CREATE_PROFESSIONAL: "Agregar Profesional",
  EDIT_PROFESSIONAL: "Editar profesional",
  DELETE_PROFESSIONAL: {
    TITLE: "Eliminar profesional",
    TEXT: "¿Estás seguro de que quieres eliminar a este profesional?",
  },
};

export const ContentFormsLabels = {
  TITLE: "Título",
  LINK: "Enlace",
  IMAGE: "Imagen",
  ENABLED: "Habilitado",
  AUTHOR: "Autor",
  PACKAGE: "Intervención",
  START_DATE: "Inicio",
  END_DATE: "Final",
  SCORE: "Puntuación",
  VISITED: "Visitado",
  VISITED_LINK: "Enlace visitado",
  FIRST_VISITED: "Primera visita",
  LABEL: "Etiqueta",
  NOTIFICATION_TEXT: "Texto de notificación",
  PACKAGE_LABEL: "Etiqueta de la intervención",
  CONTENT_TYPE: "Tipo de contenido",
  CONTENT_ERROR: "Es necesario rellenar la descripción o el enlace",
  MAX_TITLE_LENGTH: "Se ha alcanzado la longitud máxima de 100 caracteres",
  MAX_LABEL_LENGTH: "Se ha alcanzado la longitud máxima de 30 caracteres",
  SEARCH_TITLE: "Filtrar por título",
  SEARCH_LABEL: "Filtrar por etiqueta",
  SEARCH_RESET: "Eliminar filtros",
  INPUT_ERROR: "Hay campos de texto con errores",
  FULL_SCREEN: "Pantalla completa",
  FEATURED: "Destacado"
};

export const ContentTypeTranslation = {
  IMAGE: "Imagen",
  VIDEO: "Video",
  DOCUMENT: "Documento",
  WEB: "Web",
};

export const PatientsTableModals = {
  CREATE_PATIENT: "Agregar Participante",
  EDIT_PATIENT: "Editar Participante",
  DELETE_PATIENT: {
    TITLE: "Eliminar participante",
    TEXT: "¿Estás seguro de que quieres eliminar a este participante?",
  },
};

export const ChartDataLabel = {
  TOTAL_STEPS: "Pasos totales",
  AVERAGE_STEPS: "Pasos promedio",
  MIN_HEART_RATE: "Mínima",
  MAX_HEART_RATE: "Máxima",
  TOTAL_CALORIES: "Calorías totales",
};

export const LabelsLogOut = {
  LOG_OUT: "Cerrar sesión",
  TEXT: "¿Estás seguro de que quieres desconectarte?",
  CANCEL: "Cancelar",
  SURE: "Desconectar",
};

export const HomeTexts = {
  CHOOSE_DATA_EMPTY: "Selecciona un participante para ver datos",
  CHOOSE_DATA: "Selecciona un participante",
  PARTICIPANT_NOT_SELECTED: "SELECCIONA UN PARTICIPANTE PARA VER SUS DATOS",
};

export const SnackBarResponses = {
  LOGIN_ERROR:
    "Estas credenciales no coinciden con nuestros registros. Revísalas y vuelve a intentarlo",
  LOGIN_ERROR_GENERIC: "Error de login. Inténtalo más tarde",
  LOGIN_ERROR_403:
    "Este usuario no coinciden con nuestros registros. Revísalo y vuelve a intentarlo",
  LOGIN_EMPTY: "Asegúrate de completar todos los campos",
  EMAIL_FORMAT_ERROR:
    "El correo electrónico proporcionado no tiene el formato correcto",
};

export const Sex = {
  SEX: "Sexo",
  MAN: "Hombre",
  WOMAN: "Mujer",
  OTHER: "Otros",
};

export const studiesTexts = {
  LOADING_FORMS: "Cargando estudio y formularios...",
  LOADING_ANSWERS: "Se está cargando la tabla de respuestas...",
  LOADING_ERROR:
    "Se ha producido un error al obtener más respuestas. Por favor, inténtalo de nuevo.",
  SELECT_FORM_DROPDOWN: "Selecciona un formulario",
  TABLE_TITLE: "Formulario de respuestas",
  SELECT_FORM:
    "Selecciona un formulario del menú desplegable de arriba para ver las respuestas",
  NO_ANSWERS: "No se han encontrado respuestas en este formulario",
  DELETE_TITLE: "Eliminar respuestas",
  DELETE_CONFIRM:
    "¿Estás seguro de que quieres eliminar las siguientes respuestas?",
  DOWNLOAD_TITLE: "Descargar Respuestas",
  STUDY_LOADING_ERROR: "No se puede cargar el estudio, inténtalo de nuevo",
  ANSWERS_ERROR:
    "No se puede cargar la tabla de respuestas. Por favor, inténtalo de nuevo",
  DELETE_ERROR: "Se ha producido un error al eliminar la respuesta",
  EXPORT_NO_DATA:
    "No hay datos para exportar, prueba a cambiar las fechas seleccionadas",
};

export const notesTexts = {
  LOADING: "Se están cargando las notas...",
  LOADING_ERROR: "Se ha producido un error al cargar las notas",
  LOADED: "Notas cargadas",
  CREATE: "Crea una nota",
  CREATED: "Se ha creado una nueva nota",
  CREATION_ERROR: "Se ha producido un error al crear la nota",
  EDITED: "La nota se ha editado",
  EDITED_ERROR: "Se ha producido un error al editar la nota",
  DELETED_TITLE: "Eliminar Nota",
  DELETED_CONFIRM: "¿Está seguro de querer eliminar esta nota?",
  DELETED: "La nota se ha eliminado",
  DELETED_ERROR: "Se ha producido un error al eliminar la nota",
  NO_DATA: "No hay notas asociadas a este participante",
  NO_DATA_FILTERS: "No hay notas con ese filtro",
  DATE: "Fecha de la nota",
  NOTE: "Nota",
  formInputErrors: {
    note: "La nota debe tener al menos dos caracteres",
    api_error: "La nota no ha podido ser creada",
  },
};

export const alertsTexts = {
  LOADING: "Se están cargando las alertas...",
  LOADING_ERROR: "Se ha producido un error al cargar las alertas",
  LOADED: "Alertas cargadas",
  DELETED: "La alerta se ha eliminado",
  DELETED_ERROR: "Se ha producido un error al eliminar la alerta",
  NO_DATA: "No hay alertas asociadas a este centro",
  DATE: "Fecha de la alerta",
  VIEWED: "La alerta seleccionada se ha marcado como vista",
  VIEWED_ERROR: "Error: no se puede marcar la alerta seleccionada como vista",
};

export const messagesTexts = {
  TITLE: "Crear Mensaje",
  LOADING: "Se están cargando los mensajes...",
  LOADING_ERROR: "Se ha producido un error al cargar los mensajes",
  LOADED: "Mensajes cargados",
  CREATED: "Se ha creado un nuevo mensaje",
  CREATION_ERROR: "Se ha producido un error al crear el mensaje",
  EDITED: "El mensaje se ha editado correctamente",
  EDITED_ERROR: "Se ha producido un error al editar el mensaje",
  DELETED_TITLE: "Eliminar Mensaje",
  DELETED: "El mensaje se ha eliminado",
  DELETED_CONFIRM: "¿Está seguro de querer eliminar este mensaje?",
  DELETED_ERROR: "Se ha producido un error al eliminar el mensaje",
  NO_DATA: "No hay mensajes asociados a este participante",
  NO_DATA_FILTERS: "No hay mensajes con ese filtro",
  DATE: "Fecha del mensaje",
  FORM_TITLE: "Título",
  FORM_MESSAGE: "Mensaje",
  formInputErrors: {
    title: "El título debe tener al menos dos caracteres",
    message: "El mensaje debe tener al menos dos caracteres",
    api_error: "El mensaje no ha podido ser creado",
  },
};

export const contentTexts = {
  TITLE_CENTRE: "Contenido del centrO",
  TITLE_PATIENTS: "Contenido de los participantes",
  ASSOCIATE_CENTERS: "Centros asociados",
  ASSOCIATE_COMPONENT: "Componentes asociados",
  ASSOCIATED: "El contenido se ha asociado correctamente al participante",
  ASSOCIATION_ERROR:
    "Se ha producido un error al asociar el contenido a un participante",
  LOADING: "Se está cargando el contenido...",
  LOADING_ERROR: "Se ha producido un error al cargar el contenido",
  LOADED: "Contenido cargado",
  CREATED_TITLE: "Crear Contenido",
  CREATED: "Se ha creado nuevo contenido",
  CREATION_ERROR: "Se ha producido un error al crear el contenido",
  EDITED: "El contenido se ha editado correctamente",
  EDIT_TITLE: "Editar contenido",
  EDITED_NO_DATA: "Debe editar al menos un campo",
  EDITED_ERROR: "Se ha producido un error al editar el contenido",
  DELETE_TITLE: "Eliminar contenido",
  DELETED: "El contenido se ha eliminado",
  DELETED_ERROR: "Se ha producido un error al eliminar el contenido",
  DELETE_CONFIRM: "¿Estás seguro de que quieres eliminar este contenido?",
  DUPLICATE_CENTER: "Crear duplicación de contenidos en otros centros",
  SELECT: "Selecciona todos los ",
  ASSOCIATE_PATIENT: "Crear asociación de contenido con participante",
  NO_DATA: "No hay contenido asociado a este centro",
  NO_DATA_FILTERS: "No hay contenido con ese filtro",
  DROPDOWNOPTIONS: {
    VIDEO: { name: "Vídeo", value: "VIDEO" },
    IMAGE: { name: "Imagen", value: "IMAGE" },
    DOCUMENT: { name: "Documento", value: "DOCUMENT" },
    WEB: { name: "Web", value: "WEB" },
  },
  formInputErrors: {
    title_min: "El título debe tener al menos 2 caracteres",
    title_max: "El título no puede tener mas de 100 caracteres",
    label_min: "La etiqueta debe tener al menos dos caracteres",
    label_max: "La etiqueta no puede tener mas de 30 caracteres",
    contentType: "Debe seleccionar un tipo de contenido",
    descriptionOrLink: "Es necesario rellenar la descripción o el enlace",
    api_error: "El contenido no ha podido ser creado",
  },
};

export const patientContentTexts = {
  SELECTED_PATIENT: "Participante Seleccionado: ",
  LOADING: "Se está cargando el contenido del participante...",
  LOADING_ERROR:
    "Se ha producido un error al cargar el contenido del participante",
  LOADED: "Se ha cargado el contenido del participante",
  EDITED: "El contenido del participante se ha editado correctamente",
  EDITED_ERROR:
    "Se ha producido un error al editar el contenido del participante",
  DELETED: "El contenido del participante se ha eliminado",
  DELETED_ERROR:
    "Se ha producido un error al eliminar el contenido del participante",
  NO_DATA: "No hay contenido asociado a este participante",
};

export const professionalTexts = {
  LOADING: "Los profesionales se están cargando...",
  LOADING_ERROR: "Se ha producido un error al cargar los profesionales",
  LOADED: "Profesionales cargados",
  CREATED: "Se ha creado nuevo profesional",
  CREATION_ERROR: "Se ha producido un error al crear un profesional",
  EDITED: "El profesional se ha editado correctamente",
  EDITED_ERROR: "Se ha producido un error al editar un profesional",
  DELETED: "El profesional se ha eliminado",
  DELETED_ERROR: "Se ha producido un error al eliminar un profesional",
  NO_DATA: "No hay profesionales asociados a este centro",
  NO_DATA_FILTERS: "No hay profesionales con ese filtro",
  formInputErrors: {
    firstName: "El nombre es requerido y debe tener como mínimo dos caracteres",
    lastName: "El apellido debe tener al menos dos caracteres",
    email: "Debe ser un email valido",
    password:
      "La contraseña debe contener al menos 8 dígitos, una mayúscula, una minúscula y un número o uno de los siguientes símbolos: @$!%*?&",
    confirmPassword: "Las contraseñas no coinciden",
    role: "Debe seleccionar un rol",
    center: "Al menos un centro debe ser seleccionado",
    api_error: "El profesional no ha podido ser creado"
  },
};

export const patientsTexts = {
  CREATION_DATE: "Fecha registro",
  FIRST_LOGIN: "Primer acceso",
  LAST_ACCESS: "Último acceso",
  LOADING: "Los participantes se están cargando...",
  LOADING_ERROR: "Se ha producido un error al cargar los participantes",
  LOADED: "Participantes cargados",
  CREATED: "Se ha creado nuevo participante",
  CREATION_ERROR: "El participante no ha podido ser creado",
  EDITED: "El participante se ha editado correctamente",
  EDITED_ERROR: "Se ha producido un error al editar un participante",
  DELETED: "El participante se ha eliminado",
  DELETED_ERROR: "Se ha producido un error al eliminar un participante",
  NO_DATA: "No hay participantes asociados a este centro",
  NO_DATA_FILTERS: "No hay participantes con ese filtro",
  IMPORT_NOTIFICATIONS: {
    SUCCESS: "Participantes creados correctamente",
    WARNINGS: {
      EXISTING_PATIENTS:
        "Se han encontrado participantes ya existentes, solo los nuevos participantes han sido creados",
      SOME_ERRORS:
        "No todos los participantes han sido creados, corrobora que todos los datos sean correctos",
    },
    ERRORS: {
      NO_NEW_PATIENTS: "No se han encontrado nuevos participantes",
      NO_NEW_PATIENTS_AND_ERRORS:
        "No se han encontrado nuevos participantes y se han detectado errores en los datos de algunos participantes",
    },
  },
  formInputErrors: {
    firstName: "El nombre es requerido y debe tener como mínimo dos caracteres",
    lastName: "El apellido debe tener al menos dos caracteres",
    email: "Debe ser un email valido",
    password:
      "La contraseña debe contener al menos 8 dígitos, una mayúscula, una minúscula y un número o uno de los siguientes símbolos: @$!%*?&",
    confirmPassword: "Las contraseñas no coinciden",
    role: "Debe seleccionar un rol",
    center: "Al menos un centro debe ser seleccionado",
    api_error: "El profesional no ha podido ser creado"
  },
  SELFREGISTRATION_TITLE: "Check auto registro",
  selfRegistration: {
    acceptedTermsPrivacy: "Acepto los términos y condiciones y la política de privacidad",
    understandNotSharedCompany: "Entiendo que mis datos no se compartirán con mi empleador",
    consentShare: "Doy mi consentimiento para compartir mis datos anonimizados",
    mantainData: "Deseo conservar mis datos para poder rehacer la intervención"
  }
};

export const centersTexts = {
  UUID: "UUID",
  NAME: "Nombre",
  APP: "App",
  PACKAGE: "Intervención",
  ORGANIZATION: "Organización",
  ACTIVE: "Activo",
  TABLE_TITLE: "Gestión de centros",
  LOADING: "Se están cargando los centros...",
  LOADING_ERROR: "Se ha producido un error al cargar los centros",
  LOADED: "Centros cargados",
  CREATED_TITLE: "Crea un centro",
  CREATED: "Se ha creado un nuevo centro",
  CREATION_ERROR: "Se ha producido un error al crear un centro",
  EDITED_TITLE: "Editar centro",
  EDITED: "El centro se ha editado con éxito",
  EDITED_ERROR: "Se ha producido un error al editar un centro",
  EDITED_NO_DATA: "Debe editar al menos un campo",
  DELETED_TITLE: "Eliminar centro",
  DELETED: "El centro se ha eliminado correctamente",
  DELETED_ERROR: "Se ha producido un error al eliminar un centro",
  DELETED_CONFIRM: "¿Estás seguro de que quieres eliminar este centro?",
  DUPLICATE: "Duplicar Centro",
  NO_DATA: "No se han encontrado centros",
  NO_DATA_FILTERS: "No hay centros con ese filtro",
  LINKED_STUDY: "Nombre del estudio asociado",
  SELECT_SECTIONS: "¿Qué secciones quieres incluir en el nuevo centro?",
  CENTER_CONFIG: "Configuración avanzada",
  DASHBOARD_CONFIG: "Opciones de datos de salud",
  PARTICIPANTS: "Número máximo de participantes:",
  PARTICIPANTS_LABEL: "Participantes Máximos",
  PARTICIPANTS_ERROR: "Introduce un número válido",
  REGISTRATION: "Aceptar autoregistro",
  LINK_NO_DATA: "Link no disponible",
  CENTER_COMPONENTS: "Componentes del centro",
  COMPONENTS_MIN: "Al menos un componente debe ser seleccionado",
  formInputErrors: {
    name: "El nombre del centro es requerido y debe tener como mínimo dos caracteres",
    name_error: "El nombre de centro seleccionado ya existe"
  },
};

export const configFormsTexts = {
  LOADING: "Se está cargando la configuración de los formularios...",
  LOADING_ERROR:
    "Se ha producido un error al cargar la configuración de los formularios",
  LOADED: "Se ha cargado la configuración de formularios",
  CREATED_TITLE: "Crear formulario",
  CREATED: "Se ha creado una nueva configuración de formulario",
  EDITED_TITLE: "Editar el formulario",
  CREATION_ERROR:
    "Se ha producido un error al crear una configuración de formulario",
  EDITED: "La configuración del formulario se ha editado correctamente",
  DELETED_TITLE: "Eliminar el formulario",
  EDITED_ERROR:
    "Se ha producido un error al editar la configuración de los formularios",
  DELETED: "La configuración del formulario se ha eliminado correctamente",
  DELETED_CONFIRM: "¿Estás seguro de que quieres suprimir este formulario?",
  DELETED_ERROR:
    "Se ha producido un error al eliminar la configuración de los formularios",
  NO_DATA: "No se ha encontrado ninguna configuración de formulario",
  NO_DATA_FILTERS: "No hay formularios con ese filtro",
};

export const componentTexts = {
  COMPONENT: "Componentes",
  FORMS: "Formularios",
  CONTENT: "Contenido",
  MESSAGES: "Mensajes",
};
export const taskSchedulerTexts = {
  DAY: "día",
  DAYS: "días",
  WEEK: "semana",
  WEEKS: "semanas",
  MONTH: "mes",
  MONTHS: "meses",
  TYPE: "Tipo",
  RELATIVE: "Relativo",
  SPECIFIC: "Específico",
  START: "Inicio",
  END: "Fin",
  RELATIVE_WEEK: "Semana relativa",
  RELATIVE_WEEK_HELPER_TEXT:
    "Número de semanas hasta el inicio de la tarea (0 es la primer semana)",
  REPEATS: "Se repite",
  REPEATS_ARIA: "repetir tarea",
  EVERY: "Cada",
  NEVER: "Nunca",
  AFTER: "Después de",
  REPETITION: "repetición",
  REPETITIONS: "repeticiones",
  INPUT_ERROR_UPDATE_VALUE: "No es posible actualizar este valor",
  INPUT_ERROR_GREATER_ZERO: "El valor debe ser igual o superior a 0",
  INPUT_ERROR_MINOR_HUNDRED: "El valor debe ser menor que 100",
  SCHEDULE_TYPE_ERROR: "Tipo de tarea incorrecto",
};

export const packagesTexts = {
  NAME: "Nombre",
  STATUS: "Activo",
  WIZARD: "Wizard",
  PHYSICALACTIVITY: "Tipo de actividad física",
  BREADCRUMBS: "Intervenciones",
  CREATE: "Crea una intervención",
  CREATED: "Se ha creado una nueva intervención",
  LOADER: "Cargando inervenciones...",
  LOADING_ERROR:
    "Se ha producido un error al obtener las intervenciones Por favor, inténtalo de nuevo.",
  NO_DATA: "No se ha encontrado ninguna intervención",
  NO_DATA_FILTERS: "No hay intervenciones con ese filtro",
  EDITED: "La intervención se ha editado",
  formInputErrors: {
    name: "El nombre debe tener al menos dos caracteres",
    description: "La descripción debe tener al menos dos caracteres",
    api_error: "La intervención no ha podido ser creada",
    form: "Debe seleccionar un formulario",
    package: "Debe seleccionar una intervención",
  },
}

export const reportsTexts = {
  NO_DATA: "No se ha encontrado ningún reporte para este participante",
  LOADING_ERROR: "Se ha producido un error al cargar los reportes",
  NO_DATA_FILTERS: "No hay reportes con ese filtro",
};

export const scoreCardTexts = {
  SCORE_CARD: "Puntuación de adherencia",
  FORMS: "Formularios",
  FILLED: "Completados: ",
  ASSIGNED: "Asignados: ",
  CONTENT: "Contenido",
  READ: "Leídos: ",
  LAST_SCORE: "Última Puntuación: ",
  MESSAGES: "Mensajes"
}

export const scheduledForms = {
  FORM_TITLE: "Título del formulario",
  FORM_NAME: "Nombre en Studies",
  STUDY_NAME: "Nombre del estudio",
  DESCRIPTION: "Descripción",
  PACKAGE: "Intervención",
  PACKAGE_LABEL: "Etiqueta de la intervención",
  DAYS_OPEN: "Número de días en los que el formulario permanecerá abierto",
  DAYS: "Días",
  PRIORITY: "Prioridad",
  IMPORTANT: "Importante",
  REQUIRED: "Obligatorio",
  NOT_REQUIRED: "No obligatorio",
  FORM: "Formulario",
  TITLE: "Programar Formularios",
  BREADCRUMBS: "Formularios Programados",
  LOADING: "Se está cargando la programación de los formularios...",
  LOADED: "Se ha cargado la programación de formularios",
  LOADING_ERROR:
    "Se ha producido un error al cargar los formularios programados",
  CREATED: "Se ha creado una nueva programación de formulario",
  CREATED_TITLE: "Crear formulario programado",
  EDITED: "La programación del formulario se ha editado correctamente",
  EDITED_TITLE: "Editar el formulario programado",
  EDITED_ERROR:
    "Se ha producido un error al editar la programación de los formularios",
  DELETED: "La programación del formulario se ha eliminado correctamente",
  DELETED_TITLE: "Eliminar el formulario",
  DELETED_CONFIRM: "¿Estás seguro de que quieres suprimir este formulario?",
  DELETED_ERROR:
    "Se ha producido un error al eliminar la programación de los formularios",
  NO_DATA: "No se ha encontrado ninguna programación de formulario",
  NO_DATA_PATIENT: "No se ha encontrado ninguna programación de formulario para este paciente",
  NO_DATA_FILTERS: "No hay formularios con ese filtro",
  formInputErrors: {
    tag: "La etiqueta debe tener al menos dos caracteres",
    description: "La descripción debe tener al menos dos caracteres",
    api_error: "El formulario no ha podido ser creado",
    form: "Debe seleccionar un formulario",
    package: "Debe seleccionar una intervención",
  },
}

export const navBarTooltips = {
  CENTERS: "Gestión de centros",
  COMPONENTS: "Componentes",
  INTERVENTIONS: "Intervenciones de los componentes",
  PACKAGES: "Intervenciones",
  ORGANIZATIONS: "Organizaciones"
}

export const organizationsTexts = {
  BREADCRUMBS: "Organizaciones",
  NAME: "Nombre",
  CLAIM: "Eslogan",
  MERCHANT: "Comerciante",
  LOGO: "Logo",
  MERCHANTLOGO: "Logo del comerciante",
  CREATE: "Crear organización",
  CREATED: "Se ha creado una nueva organización",
  LOADING_ERROR:
    "Se ha producido un error al obtener las organizaciones Por favor, inténtalo de nuevo.",
  EDIT: "Editar organización",
  EDITED: "La organización se ha editado",
  DELETED_TITLE: "Eliminar organización",
  DELETED: "La organización se ha eliminado",
  DELETED_CONFIRM: "¿Está seguro de querer eliminar esta organización?",
  DELETED_ERROR: "Se ha producido un error al eliminar la organización",
  LOADER: "Cargando organizaciones...",
  NO_DATA: "No se ha encontrado ninguna organización",
  NO_DATA_FILTERS: "No hay organizaciones con ese filtro",
  formInputErrors: {
    name: "El nombre debe tener al menos dos caracteres",
    description: "La descripción debe tener al menos dos caracteres",
    api_error: "La organización no ha podido ser creada",
  },
}

